import { ChatsApi } from "@/api/chats";
import { StartFeedbackChatRequest } from "@/api/chats/types";
import { QueryKey } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotify } from "react-admin";
import { getChatMessagesQuery } from "./get-chat-messages.query";
import { FeedbackTab, useSupportContext } from "@/stores";

export const useStartFeedbackChat = () => {
  const queryClient = useQueryClient();
  const { dispatch, currentChat } = useSupportContext();
  const notify = useNotify();

  const { mutate: startFeedbackChat, isPending } = useMutation({
    mutationFn: (body: StartFeedbackChatRequest) =>
      ChatsApi.startFeedbackChat(body),
    onError: (error) => {
      notify(error, { type: "error" });
    },
    onSuccess: ({ id: chatId }) => {
      getChatMessagesQuery({ chatId });
      queryClient.invalidateQueries({
        queryKey: [QueryKey.ACTIVE_SUPPORT_CHATS],
      });
      queryClient.invalidateQueries({
        queryKey: [QueryKey.FEEDBACKS],
      });
      if (currentChat) {
        dispatch({
          type: "SET_CURRENT_CHAT",
          payload: { ...currentChat, id: chatId, isActive: true },
        });
        dispatch({
          type: "SET_FEEDBACK_TAB",
          payload: FeedbackTab.IN_PROGRESS,
        });
      }
    },
  });

  return {
    startFeedbackChat,
    isStartFeedbackChatLoading: isPending,
  };
};
